import React, { useContext } from 'react'
import { Switch } from 'react-router-dom'

import { PrivateRoutes } from './Index'

import EventsFiltersContextProvider from '../context/EventsFiltersContext'
import { AuthContext } from '../context/AuthContext'

import EventsMonitoringOverview from '../pages/Events/Index'

export default function EventsRoutes (): JSX.Element {
  const { auth } = useContext(AuthContext)
  return (
    <EventsFiltersContextProvider>
      <Switch>
        <PrivateRoutes path="/analise-de-eventos/overview" component={EventsMonitoringOverview} auth={auth} />
      </Switch>
    </EventsFiltersContextProvider>
  )
}
